export const SET_FLIP = 'features/SET_FLIP';
